import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/home/client/client-1.webp")